<template>
    <div style="height: 100%;">
        <div>菜单列表</div>
        <div class="menuList">
            <ul>
                <li v-for="item in menuItems" :key="item.id" @click="showComponent(item.component)">{{ item.name }}</li>
            </ul>
        </div>
    </div>
</template>
<script>
    import menuViewMap from '@/router/menuViewMap';

    export default {
        name: 'menuList',
        data() {
            return {
                menuItems:[]
            }
        },
        created(){
            for(var menuCode in menuViewMap){
                //首页不加入，否则会出现多个首页嵌套的问题
                if(menuCode == "tjmain" ){
                    continue;
                }
                this.menuItems.push({"name":menuCode, "component":menuCode});
            }
        },
        methods:{
            showComponent(component){
                this.$emit('component-selected', component);
            }
        }
    }
</script>
<style scoped>
    div.menuList{
        height: 100%;
        overflow: auto;
        padding-bottom: 10px;
    }
    
    .menuList::-webkit-scrollbar {
        width: 2px;
    }
    
    .menuList::-webkit-scrollbar-track {
        background: rgba(255,255,255,0);
        border-radius: 1px;
    }
    
    .menuList::-webkit-scrollbar-thumb {
        background: rgba(200,200,200,0.3);
        border-radius: 1px;
        border: 0px solid #f1f1f1;
    }
    
    li {
        font-size: 12px;
        color: black;
        padding-top:3px;
        padding-bottom: 3px;
        padding-left: 10px;
        font-weight: 500;
        text-align: left;
        &:hover{
            cursor: pointer;
            color: red;
            background-color: rgba(255,125,125,0.3);
        }
    }
</style>